import { FormControlLabel, Stack, Switch, TextField } from "@mui/material";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import {
  agreementOriginalOptions,
  agreementStatusOptions,
} from "src/entities/partnerContracts/model/constants/common";
import { DatePickerField, FileInput, SelectField } from "src/shared/components";
import { messages } from "src/shared/utils/hookFormRules";
import { IAgreementFormValues } from "../../../model/types";

interface AgreementFormProps {
  attachmentUrl?: string;
}

export function AgreementForm({ attachmentUrl }: AgreementFormProps) {
  const methods = useFormContext<IAgreementFormValues>();
  const { control } = methods;
  const showFileInput = useWatch({
    control,
    name: "data.is_agreement_with_edits",
  });

  return (
    <Stack direction="column" spacing={4}>
      <Controller
        name="data.agreement_date"
        control={control}
        render={({ field: { ref, ...field }, fieldState: { error } }) => (
          <DatePickerField
            inputRef={ref}
            {...field}
            disableFuture
            error={error}
            label="Дата соглашения"
          />
        )}
        rules={{ required: messages.required }}
      />
      <Controller
        control={control}
        name="data.is_active"
        render={({ field: { ref, ...field }, fieldState: { error } }) => (
          <SelectField<boolean>
            inputRef={ref}
            fullWidth
            {...field}
            label="Статус соглашения"
            error={!!error}
            helperText={error?.message}
            options={agreementStatusOptions}
          />
        )}
      />
      <Controller
        control={control}
        name="data.is_original_presented"
        render={({ field: { ref, ...field }, fieldState: { error } }) => (
          <SelectField<boolean>
            inputRef={ref}
            fullWidth
            {...field}
            label="Наличие оригинала"
            error={!!error}
            helperText={error?.message}
            options={agreementOriginalOptions}
          />
        )}
      />

      <Controller
        control={control}
        name="data.note"
        render={({ field: { ref, ...field } }) => (
          <TextField
            inputRef={ref}
            fullWidth
            {...field}
            label="Примечание"
            multiline
            rows={3}
            slotProps={{
              htmlInput: {
                maxLength: 255,
              },
            }}
          />
        )}
      />
      <Controller
        control={control}
        name="data.is_agreement_with_edits"
        render={({ field }) => (
          <FormControlLabel
            control={
              <Switch
                {...field}
                checked={!!field.value}
                onChange={(e) => field.onChange(e.target.checked)}
              />
            }
            label="Доп. соглашение с правками"
          />
        )}
      />
      {showFileInput && (
        <Controller
          control={control}
          name="file"
          rules={{
            validate: (file) => {
              if (file && file.size > 10 * 1024 * 1024) {
                return messages.maxFileSizeMb;
              }

              return true;
            },
          }}
          render={({ field, fieldState: { error } }) => (
            <FileInput
              error={!!error}
              helperText={error?.message}
              {...field}
              onChange={(e) => {
                field.onChange(e?.target.files?.[0] || null);
              }}
              value={field.value || undefined}
              accept=".pdf"
              tooltip="Только форматы: *.PDF"
              attachmentUrl={attachmentUrl}
            />
          )}
        />
      )}
    </Stack>
  );
}
